import * as footer from "./footer";
import * as page_height from "./page_height";

export function watch() {

    $(window).on('close.bs.alert', function(e){
        e.preventDefault();
        e.stopPropagation();

        let loop = setInterval(function () {
            page_height.watch();
            footer.watch();
        }, 1); // Defaut : 1

        $(e.target).animate({
            opacity: 0,
            left: "-=50",
        }, 300, function() {
            $(e.target).slideUp(function () {
                $(e.target).remove();

                clearInterval(loop);
            });
        });
    });

    return true;
}